import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=25c5fd7a&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=ts"
export * from "./SimpleButton.vue?vue&type=script&lang=ts"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=25c5fd7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5fd7a",
  null
  
)

export default component.exports